<template>
    <v-layout wrap>
        <v-flex xs12>
            <div class="font-weight-light title">
                <img :src="event.imgurl" height="100" /><br/>
                Register<br/>
                <span v-for="p in players" :key="p.partkey" class="mr-1 font-weight-light headline">{{p.firstname}} {{p.lastname}}</span>
                <br/>
                for {{event.name}} - {{sku.attributes.name}}
            </div>
            <div>
                {{event.description}}<br/>
                {{sku.metadata.date}}
                {{sku.metadata.time}}<br/>

            </div>
            <div class="font-weight-light headline">
                Price:  ${{sku.price/100}}
            </div>
        </v-flex>
        <v-flex xs12>
            <BaseBtn @click="confirm">Confirm and <v-icon class="ml-2">fa fa-arrow-circle-right</v-icon></BaseBtn>
        </v-flex>
    </v-layout>
</template>

<script>
  import BaseBtn from "../BaseBtn";
  export default {
    props:['sku'],
    components: {BaseBtn},
    name: "TeamCard",
    data() {
      return {}
    },
    computed:{
      players(){
        return this.$store.state.registrants
      },
      event(){
        return this.$store.state.event.event
      }
    },
    mounted() {
    },
    methods: {
      confirm(){
        this.$store.commit('setRegistrationStep',3)
      }
    }
  }
</script>

<style scoped>

</style>